module.exports = __webpack_public_path__ + "img/icon-electric-vehicle.267ae745.svg";